import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ProductVariant } from 'src/app/classes/utility';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  public variantSubject = new ReplaySubject<ProductVariant>(1);
  public variantObservable = this.variantSubject.asObservable();

  constructor() {}
}
